import * as R from "remeda";
import { DeleteWithConfirmButton, useNotify } from "react-admin";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";

type RemoveWithConfirmButtonProps = {
	confirmContent: string;
	notifyMessage: string;
	resource?: string;
	onDelete?: () => void;
};

export const RemoveWithConfirmButton = ({
	confirmContent,
	notifyMessage,
	resource,
	onDelete = R.noop,
}: RemoveWithConfirmButtonProps) => {
	const notify = useNotify();
	return (
		<DeleteWithConfirmButton
			confirmTitle=""
			label="Remove"
			confirmContent={confirmContent}
			icon={<DeleteOutlineIcon />}
			redirect={false}
			mutationOptions={{
				onSuccess: () => {
					onDelete();
					notify(notifyMessage);
				},
			}}
			resource={resource}
		/>
	);
};
